var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOportunity2Bg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 140,
    viewBox: "0 0 334 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 334,
    height: 140,
    fill: "#69B42E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_611_2294",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 334,
    height: 140
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 334,
    height: 140,
    fill: "#69B42E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_611_2294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.115 101.96L263.393 -47.7342C260.377 -58.0897 254.69 -67.4534 246.903 -74.883C239.117 -82.3126 229.506 -87.5459 219.039 -90.0562L67.7279 -126.443C57.2693 -128.958 46.3221 -128.665 35.9866 -125.595C25.6511 -122.524 16.2914 -116.784 8.84814 -108.951L-98.8591 4.40565C-106.333 12.2381 -111.624 21.8989 -114.197 32.4132C-116.77 42.9275 -116.535 53.9235 -113.515 64.2918L-69.8896 214.049C-66.8733 224.394 -61.1907 233.749 -53.4127 241.173C-45.6347 248.597 -36.0353 253.83 -25.5789 256.345L125.776 292.758C136.234 295.272 147.182 294.98 157.517 291.909C167.853 288.838 177.212 283.098 184.656 275.265L292.459 161.846C299.933 154.014 305.224 144.353 307.797 133.839C310.37 123.325 310.135 112.329 307.115 101.96V101.96Z",
    fill: "url(#paint0_linear_611_2294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26 86.6883L193.021 -9.10663C190.935 -15.7336 187.142 -21.6848 182.024 -26.3611C176.906 -31.0375 170.644 -34.274 163.868 -35.745L65.9178 -57.0738C59.1476 -58.5476 52.1017 -58.2068 45.4883 -56.0856C38.8749 -53.9644 32.9271 -50.1375 28.2427 -44.9895L-39.544 29.51C-44.2485 34.6581 -47.5213 40.9532 -49.0322 47.7602C-50.5431 54.5672 -50.2387 61.6453 -48.1496 68.2805L-17.9717 164.117C-15.8853 170.737 -12.0956 176.683 -6.98328 181.356C-1.871 186.029 4.38377 189.265 11.1526 190.739L109.131 212.084C115.902 213.558 122.948 213.217 129.561 211.096C136.174 208.975 142.122 205.148 146.807 200L214.654 125.459C219.359 120.311 222.632 114.016 224.143 107.209C225.653 100.402 225.349 93.3234 223.26 86.6883V86.6883Z",
    fill: "url(#paint1_linear_611_2294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.007 43.0019L117.407 1.45188C114.325 -1.42412 110.539 -3.43742 106.431 -4.38539C102.324 -5.33335 98.0385 -5.18254 94.0074 -3.94812L35.7174 13.8619C31.6885 15.0931 28.0547 17.3631 25.1812 20.4438C22.3077 23.5244 20.2957 27.3072 19.3474 31.4119L5.62742 90.8119C4.66857 94.9226 4.81082 99.2134 6.03983 103.252C7.26883 107.29 9.54111 110.932 12.6274 113.812L57.2074 155.402C60.2879 158.274 64.0702 160.286 68.1741 161.234C72.2781 162.181 76.5592 162.033 80.5874 160.802L138.897 142.992C142.926 141.761 146.56 139.491 149.434 136.41C152.307 133.329 154.319 129.547 155.267 125.442L169.007 66.0019C169.966 61.8912 169.824 57.6003 168.595 53.5622C167.366 49.524 165.094 45.8814 162.007 43.0019V43.0019Z",
    fill: "url(#paint2_linear_611_2294)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_611_2294",
    x1: -50.3501,
    y1: -42.6836,
    x2: 314.807,
    y2: -39.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FEA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B42E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_611_2294",
    x1: -8.95919,
    y1: -1.49016,
    x2: 260.815,
    y2: 166.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FEA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B42E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_611_2294",
    x1: 87.7898,
    y1: -52.321,
    x2: 239.79,
    y2: 131.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FEA63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B42E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOportunity2Bg);
export default __webpack_public_path__ + "static/media/Oportunity2Bg.85b34a0289107f4161a059301a6825ee.svg";
export { ForwardRef as ReactComponent };